import { service } from '../../../../helpers/http'

export const ActionIndexDynamicJoins = ({ dispatch }, payload) => {

    return service({
        module: 'dynamicGeneration',
        action: 'indexDynamicJoins',
        payload: payload
    })
    
}

export const ActionCreateDynamicJoin = ({ dispatch }, payload) => {
    
    return service({
        module: 'dynamicGeneration',
        action: 'createDynamicJoin',
        payload: payload
    })
    
}

export const ActionUpdateDynamicJoin = ({ dispatch }, payload) => {
    
    return service({
        module: 'dynamicGeneration',
        action: 'updateDynamicJoin',
        payload: payload
    })
}

export const ActionDeleteDynamicJoin = ({ dispatch }, payload) => {
    
    return service({
        module: 'dynamicGeneration',
        action: 'deleteDynamicJoin',
        payload: payload
    })
    
}

export const ActionDynamicJoinGenerate = ({ dispatch }, payload) => {

    return service({
        module: 'dynamicGeneration',
        action: 'generateDynamicJoin',
        payload: payload
    })
    
}

export const ActionDynamicJoinSync = ({ dispatch }, payload) => {

    return service({
        module: 'dynamicGeneration',
        action: 'syncDynamicJoin',
        payload: payload
    })
    
}

export const ActionShowDynamicJoinViewResults = ({ dispatch }, payload) => {

    return service({
        module: 'dynamicGeneration',
        action: 'showDynamicJoinViewResults',
        payload: payload,
        idAndPayload: true
    })
    
}